import { FeatureListIconVariants } from '@shared/components/@organisms/UCFeatureList/constants';
import { IUCFeatureListItem } from '@shared/components/@organisms/UCFeatureList/types';

import { ISBCustomerProposition, ISBPropositionIcon } from './types';

export const transformCustomerValuePropositions = (
  cmsItems: ISBCustomerProposition[],
): IUCFeatureListItem[] => {
  return cmsItems.map((item) => ({
    id: item._uid,
    text: item.text,
    link: item.link?.cached_url || undefined,
    icons: item.icons
      ?.map((icon: ISBPropositionIcon) => {
        if (icon.component === FeatureListIconVariants.Icon && icon.icon?.icon) {
          return {
            type: FeatureListIconVariants.Icon,
            value: icon.icon.icon,
          };
        }

        if (icon.component === FeatureListIconVariants.ThirdPartyLogo && icon.logo) {
          return {
            type: FeatureListIconVariants.ThirdPartyLogo,
            value: icon.logo,
          };
        }

        return null;
      })
      .filter(Boolean) as IUCFeatureListItem['icons'],
  }));
};
